import { ValidationSet } from '../../../types/validation';

/**
 * Validate input based on a set of rules.
 * @param input The input to validate.
 * @param validationSets The set of rules to validate the input against.
 * @returns An array of error messages.
 * */
export function validateInput(input: string, validationSets: ValidationSet[]): string[] {
  for (const validationSet of validationSets) {
    const isArray = Array.isArray(validationSet);
    if (!isArray && validationSet.condition && !validationSet.condition(input)) {
      continue;
    }
    const rules = isArray ? validationSet : validationSet.rules;
    return rules.filter(({ test }) => {
      return test(input);
    }).map(({ message }) => {
      return message;
    });
  }
  return [];
}
